import { useHttpClient } from './httpClient.js';

const resource = 'servers';

export function createServer(server) {
	return useHttpClient().post(`/${resource}`, { server });
}

export function updateServer(id, server) {
	return useHttpClient().put(`/${resource}/${id}`, { server });
}

export function fetchServers() {
	return useHttpClient().get(`/${resource}`);
}

export function fetchServer(id) {
	return useHttpClient().get(`/${resource}/${id}`);
}

export function fetchServerParams() {
	return useHttpClient().get(`/${resource}/params`);
}

export function startStream(id) {
	return useHttpClient().post(`/${resource}/${id}/start_stream`);
}

export function stopStream(id) {
	return useHttpClient().post(`/${resource}/${id}/stop_stream`);
}

export function restartStream(id) {
	return useHttpClient().post(`/${resource}/${id}/restart_stream`);
}
